import { createActions } from 'reduxsauce'

export const { Types, Creators } = createActions({
  trackAvailability: ['active'],
  trackWaitingRoom: [],
  trackWaitingRoomTooBusy: [],
  trackAgentConnected: [],
  trackBotConnected: [],
  trackEndChatWindow: [],
  trackCustomerEndedChat: [],
  trackAgentEndedChat: [],
  trackConnectionProblem: [],
  trackAnswer: ['trackingCode'],
})
